import { address as mezoMainnetAddress } from "@mezo-org/mezod-contracts/deployments/mainnet/mSolvBTC.json"
import { address as mezoTestnetAddress } from "@mezo-org/mezod-contracts/deployments/testnet/mSolvBTC.json"
import { Address } from "viem"

import artifacts from "#/shared/utils/artifacts"

export default artifacts.getBridgeableERC20TokenArtifact({
  mainnetAddress: "0x7A56E1C57C7475CCf742a1832B028F0456652F97",
  testnetAddress: "0x39AB795D11FCC6CE1c340fbDc308cF1D42ca8f86",
  mezoTestnetAddress: mezoTestnetAddress as Address,
  mezoMainnetAddress: mezoMainnetAddress as Address,
})
